export const MAX_EXCEL_PREVIEW_ROWS = 8;
export const CUSTOM_VALUE = 9999;
export const TYPE_KONTUR_FOCUS = 'konturFocus';
export const TYPE_PHOTO = 'photo';
export const KONTUR_FOCUS_ORG_FIELD = 'konturFocusOrg';

export const REQUIRED_FIELDS = [{
    name: 'email',
    label_ru: 'электронная почта',
    label_en: 'email',
}, {
    name: 'name',
    label_ru: 'имя',
    label_en: 'name',

}];

export const KONTUR_FIELDS = [{
    name: 'organizationName',
    label_ru: 'название организации',
    label_en: 'organization name',
}, {
    name: 'organizationInn',
    label_ru: 'инн',
    label_en: 'inn',
}, {
    name: 'organizationKpp',
    label_ru: 'кпп',
    label_en: 'kpp',
}];

export const CHECKBOX_SELECT_LIST = [{
    value: true,
    label_ru: 'Да',
    label_en: 'Yes',
}, {
    value: false,
    label_ru: 'Нет',
    label_en: 'No',
}];
